import { render } from "./ContactBox.vue?vue&type=template&id=1ac953d3&scoped=true"
import script from "./ContactBox.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ContactBox.vue?vue&type=script&charset=utf-8&lang=js"

import "./ContactBox.vue?vue&type=style&index=0&id=1ac953d3&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac953d3"]])

export default __exports__